import { getEditorPlugin,type SlateEditor } from '@udecode/plate';

import { BaseShortcutPlugin,type ShortcutConfig } from './BaseShortcutPlugin';
import type { TShortcutItemBase } from './types';

export type ShortcutOnSelectItem<
  TItem extends TShortcutItemBase = TShortcutItemBase,
> = (editor: SlateEditor, item: TItem, search?: string) => void;

export const getShortcutOnSelectItem =
  <TItem extends TShortcutItemBase = TShortcutItemBase>({
        key = BaseShortcutPlugin.key,
    }: { key?: string } = {}): ShortcutOnSelectItem<TItem> =>
        (editor, item, search = '') => {
            const { getOptions, tf } = getEditorPlugin<ShortcutConfig>(editor, {
                key: key as any,
            });
            const { insertSpaceAfterShortcut } = getOptions();

            tf.insert.shortcut({ key: item.key, search, value: item.text });

            // move the selection after the element
            editor.tf.move({ unit: 'offset' });

            const pathAbove = editor.api.block()?.[1];

            const isBlockEnd =
                editor.selection &&
                pathAbove &&
                editor.api.isEnd(editor.selection.anchor, pathAbove);

            if (isBlockEnd && insertSpaceAfterShortcut) {
                editor.tf.insertText(' ');
            }
        };
